import { render } from "./PointWarning.vue?vue&type=template&id=1147a444&scoped=true"
import script from "./PointWarning.vue?vue&type=script&lang=js"
export * from "./PointWarning.vue?vue&type=script&lang=js"

import "./PointWarning.vue?vue&type=style&index=0&id=1147a444&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1147a444"]])

export default __exports__